import { isBasicUser } from '@/constants/roles';

import { useAuth } from '@/hooks/useAuth';

export function useIsBasicUser(): boolean {
    const { user } = useAuth();
    return isBasicUser(user?.metadata);
}
